
        var result = require("!!../../../../../node_modules/css-loader/index.js!./customers.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/quote-settings/customers/customers.component.css
// module id = 752
// module chunks = 0